module.exports = __webpack_public_path__ + "0959d23845f2aa1f21e28289c8330b4f.png";